/* (technique which can be used for storing data in session ) import { StorageServiceModule } from 'angular-webstorage-service'  (goes in app module and then put the class in imports);  
 * import { SESSION_STORAGE, WebStorageService } from 'angular-webstorage-service'; (goes in the component.ts and declare a variable in the constructor)
 *  @Inject(SESSION_STORAGE) private storage: WebStorageService (goes in constructor)
 *  this.storage.set("Token", result.token);    (sample syntax to store in session)
 * 
 */


import { BrowserModule } from '@angular/platform-browser';
import { NgModule  } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { NgBusyModule } from 'ng-busy';



import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { LoginComponent } from './login/login.component';
import { AngularFontAwesomeModule } from 'angular-font-awesome';


import { ValidationService } from './interface/UIValidation';
import { FileUtilityService } from './interface/fileUtils';
import { RoleManager } from './interface/RoleManager';
import { RequestInterceptor } from './http-interceptor';

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    CounterComponent,
    FetchDataComponent,
    LoginComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
NgBusyModule,
    ReactiveFormsModule,
    AngularFontAwesomeModule,
    NgxSmartModalModule.forRoot(),
    RouterModule.forRoot([
      { path: '', component: LoginComponent, pathMatch: 'full' },
      { path: 'pages', loadChildren: 'app/pages/pages.module#PagesModule' },
      { path: 'login', component: LoginComponent, pathMatch: 'full' },
      { path: 'fetch-data', component: FetchDataComponent },
    ])

  ],
  providers: [ValidationService, FileUtilityService, RoleManager, {
    provide: HTTP_INTERCEPTORS,
    useClass: RequestInterceptor,
    multi: true,
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts